import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { SharedService } from "src/app/services/shared/shared.service";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { interval, Subscription } from 'rxjs';
import { LogsComponent } from "src/app/pages/logs/logs.component";
import { MatDialog } from '@angular/material/dialog';

interface HeaderFunctionConfig {
  name?: string;
  description?: string;
  field?: string;
  value?: string;
  type?: string;
  showInPreview1?: boolean;
  showInPreview2?: boolean;
}

@Component({
  selector: "app-previewDataTableTitle",
  templateUrl: "./previewDataTableTitle.component.html",
  styleUrls: ["./previewDataTableTitle.component.scss"],
  standalone: false
})
export class PreviewDataTableTitleComponent implements OnInit, OnDestroy {
  @Input() nombreFuente: string;
  domain: string;
  subdomain: string;
  @Input() isEditing: boolean = false;
  @Input() detailSelected: boolean = false;
  @Input() disableDeleteButton: boolean = false;
  @Input() disableEditButton: boolean;
  @Input() disabledSaveButton: boolean = false;
  @Input() disabledEditButtonManual: boolean = false;
  @Input() disabledAddButton: boolean;
  @Input() inDisabledEdicionMasiva: boolean;
  @Input() showEliminacionMasiva: boolean;
  @Input() showAddButton: boolean = false;
  @Input() successDIS: boolean;
  @Input() historyList: { id: string; description: string }[];
  @Input() toggleValue: boolean;
  @Input() showHistory: boolean = true;
  @Input() buttonAdd: boolean = false;
  @Input() historyListModal: any = null;

  //Inputs nueva configuracion de botones segun multipreview
  @Input() addPreview: boolean;
  @Input() deletePreview: boolean;
  @Input() bulkEditPreview: boolean;
  @Input() addPreviewTwo: boolean;
  @Input() deletePreviewTwo: boolean;
  @Input() bulkEditPreviewTwo: boolean;

  @Input() viewSoftDeleted: boolean = false;

  @Input() showRds: boolean = false;

  @Input() subTitle: string = "";
  @Input() periods: boolean = false;

  // Configuraciones GFD
  @Input() isMultiplePreview: boolean = false;
  @Input() hasMultipleConfigs: boolean = false;
  @Input() selectedConfigName: string = '';
  @Input() set showAddObservation(show: boolean) {
    this.showAddObs = (this.validRoleAdd && show);
  }
  private _baseUrlfuente: string;

  isPurpusing: boolean = false;

  @Input() set baseUrlfuente(baseUrl: string) {
    // console.log('El valor de baseUrl que llegó es:', baseUrl);
    this._baseUrlfuente = baseUrl; // Ahora esto es válido

    this.isMorosidadesVip =
      this.localStorageService.getIsVip &&
      this.domain === 'PY_CREDIT' &&
      this.subdomain === 'DELINQUENCY_EXCH';
  }

  @Input() primaryKeyFieldRdsVista: string = "";
  variableLocalPrimaryKeyFieldRdsVista: string = ""; // Variable local para almacenar el valor
  private subscription: Subscription;
  private primaryKeySubscription: Subscription;
  showMovimientosButton: boolean;
  motivoEliminacionSicomMicro: boolean;
  isSegSolicitudes = false;

  @Output() onVerFuentesButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onFiltroTabla: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onEditButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onCancelButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onToBackButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onDeleteButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onAddButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onToggleHistorial: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() onTimestampSelected: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() onNewObservation: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onViewSoftDeleted: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() onViewRds: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() onDataPrimarykeyRds = new EventEmitter<any>();
  @Output() onEdicionMasiva: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSearchRdsData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() findAllDetailPaged: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() onHeaderFunctionSelected: EventEmitter<{ functionConfig: HeaderFunctionConfig, currentView: 'preview1' | 'preview2' | 'detail' }> = new EventEmitter<{ functionConfig: HeaderFunctionConfig, currentView: 'preview1' | 'preview2' | 'detail' }>();

  @Output() onSaveEliminacionSuplantacionIdentidad: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionCancelacionPagoCarteraVencidaAlDia: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionCancelacionPagoCarteraSoloVencida: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onSaveEliminacionProveedorPeriodoActualCarteraVencidaAlDia: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionProveedorPeriodoActualCarteraSoloVencida: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionProveedorPeriodoHistoricoCarteraVencidaAlDia: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionProveedorPeriodoHistoricoCarteraSoloVencida: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionProveedorPeriodoFechaDesdeCarteraVencidaAlDia: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveEliminacionProveedorPeriodoFechaDesdeCarteraSoloVencida: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveFunction: EventEmitter<any> = new EventEmitter<any>();
  // Boton filtrar resultados por journalingTimestamp
  @Input() showOnlyLatest: boolean = false;
  @Output() onShowLatestChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // exclusive manual source use
  @Input() isCreating: boolean;

  // Input para fuentes con multiples preview
  @Input() currentView: 'preview1' | 'preview2' | 'detail';

  // Output para abrir modal de configuraciones
  @Output() onChangeConfig: EventEmitter<void> = new EventEmitter<void>();
  @Input() isAnyRowSelected: boolean = false;
  @Input() showLatestFilterSwitch: boolean = false;

  inputFilterAll: string;
  dataPrimarykeyRds: any;
  searchTable: UntypedFormGroup;
  //showAlert: boolean = false;
  tooltipNoEditableView: string = " ";

  isMorosidadesVip: boolean = true;

  showAddObs: boolean = false;
  showBusquedaRapida: boolean = false;

  componentName = "PreviewDataTableTitleComponent";

  titleButtonAdd = '';
  panelFilter: boolean = false;

  esInternoRdsVista = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;

  selectOptionsRDS = ['primarykey'];
  selectedKeyTypeRDS: string = 'primarykey'; // Valor por defecto seleccionado
  headerFunctions: HeaderFunctionConfig[] = [];
  selectedHeaderFunction: string = '';

  get validRoleAdd(): boolean {
    const permission = this.localStorageService.configInit['F_ADD_A'];
    return this.sharedService.parseRolesArray(permission).includes(this.localStorageService.getPermissionCountry.roles);
  }

  get validRoleDis(): boolean {
    if (this.showRds) {
      const rdsPermission = this.localStorageService.configInit['F_RDS_A'];
      return this.sharedService.parseRolesArray(rdsPermission).includes(this.localStorageService.getPermissionCountry.roles);
    }
    const permission = this.localStorageService.configInit['F_DIS_A'];
    return this.sharedService.parseRolesArray(permission).includes(this.localStorageService.getPermissionCountry.roles);
  }

  get disableEditar(): boolean {
    return (!this.validRoleDis || this.disableEditButton);
  }

  get disableAdd(): boolean {
    return (!this.validRoleDis || this.disabledAddButton);
  }

  get disabledHistorialHtml(): boolean {
    return this.isEditing;
  }

  get showHistoryHtml(): boolean {
    return this.showHistory && !this.isMorosidadesVip;
  }

  ngOnInit(): void {

    this.showMovimientosButton = !this.localStorageService.getIsVip;
    this.loadHeaderFunctions();

    if (this.nombreFuente) {
      this.isSegSolicitudes = this.nombreFuente.includes('Seguimiento de RequestID');
    }

    if (this.showAddObs && this.nombreFuente !== '') {
      this.titleButtonAdd = this.nombreFuente.split(' ')[0];
    }
    // this.primaryKeySubscription = this.localStorageService.getPrimaryKeyFieldRDS$.subscribe(value => {
    //   this.variableLocalPrimaryKeyFieldRdsVista = value;
    //   console.log('Variable local actualizada (Observable):', this.variableLocalPrimaryKeyFieldRdsVista);
    // });

    if (this.showRds) {
      this.primaryKeySubscription = this.localStorageService.getPrimaryKeyFieldRDS$.subscribe(value => {
        this.variableLocalPrimaryKeyFieldRdsVista = value;

        console.log('[previewDataTableTitle.varibleCicloRds] Valor actualizado en variable local:', this.variableLocalPrimaryKeyFieldRdsVista);
        console.log('[previewDataTableTitle.varibleCicloRds] this.localStorageService.fields:', this.localStorageService.fields);
        const fields = this.localStorageService.fields;

        if (fields && fields.alternateKeys) {
          const alternateKeys = fields?.alternateKeys?.sourceFields || [];

          this.selectOptionsRDS = ['primarykey', ...alternateKeys];
          console.log('[previewDataTableTitle.varibleCicloRds] alternateKeys:', alternateKeys);
        }

        this.cdr.detectChanges(); // Forzar la detección de cambios
        // console.log('Variable local actualizada (Observable):', this.variableLocalPrimaryKeyFieldRdsVista);
      });
    }

    this.isPurpusing = this.localStorageService.subdomainPurp !== '' ? true : false;

  }

  private loadHeaderFunctions(): void {
    const functions = this.localStorageService.dataEstructuraDinamicaHeader?.function;
    this.headerFunctions = Array.isArray(functions) ? functions : [];
  }

  get headerFunctionsForCurrentView(): HeaderFunctionConfig[] {
    if (!this.headerFunctions || this.headerFunctions.length === 0) {
      return [];
    }

    if (this.currentView === 'preview2') {
      return this.headerFunctions.filter(fn => fn.showInPreview2 !== false);
    }

    if (this.currentView === 'preview1') {
      return this.headerFunctions.filter(fn => fn.showInPreview1 !== false);
    }
    return [];
  }

  get hasHeaderFunctions(): boolean {
    return this.headerFunctionsForCurrentView.length > 0;
  }

  onHeaderFunctionChange(functionName: any): void {
    if (!functionName) {
      return;
    }

    console.log("functionName ---->", functionName);

    console.log("isAnyRowSelected ---->", this.isAnyRowSelected);

    this.onSaveFunction.emit(functionName);

    // const selectedFunction = this.headerFunctionsForCurrentView.find(fn => fn.name === functionName);

    // if (selectedFunction) {
    //   this.onHeaderFunctionSelected.emit({
    //     functionConfig: selectedFunction,
    //     currentView: this.currentView
    //   });
    // }


    // this.selectedHeaderFunction = '';
  }

  getTitleWithConfig(): string {
    if (this.hasMultipleConfigs && this.selectedConfigName) {
      return `${this.nombreFuente} (${this.selectedConfigName})`;
    }
    return this.nombreFuente;
  }

  ngOnDestroy(): void {
    if (this.primaryKeySubscription) {
      this.primaryKeySubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  conditionEditar() {
    const isVisible = (this.isCreating != undefined)
      ? this.isEditing == false && this.isCreating == false
      : !this.isEditing;
    const isDisabled = this.periods
      ? this.disabledEditButtonManual
      : !this.disableEditar;
    return (isVisible && isDisabled) && !this.isEditing;
  }

  conditionEditar2() {
    const isVisible = (this.isCreating != undefined)
      ? this.isEditing == false && this.isCreating == false
      : !this.isEditing;
    const isDisabled = this.periods
      ? this.disabledEditButtonManual
      : !this.disableEditar;
    return isVisible && isDisabled;
  }

  conditionEdicionMasiva() {
    return this.inDisabledEdicionMasiva;
  }

  condicionMotivoEliminacionSicomMicro() {
    const enabledSubdomain = this.domain === 'EC_CREDIT' &&
      (this.subdomain === 'SICOM_SUMMARY' || this.subdomain === 'MICROFINANCE');
    let salida = this.showEliminacionMasiva &&
      this.currentView === 'preview1' &&
      this.localStorageService.getIsVip &&
      enabledSubdomain;
    return salida;
  }

  rdsPrimarykeys: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private localStorageService: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private sharedService: SharedService,
  ) {
    this.rdsPrimarykeys = [
      { code: "", description: "" }
    ];
    // Genera Formulario para input efx
    this.createForm();
    this.varibleCicloRds();
  }

  createForm(): void {
    this.localStorageService.getMenuSelectedObs.subscribe(menu => {
      if (menu) {
        const { domainJO, subDomainJO } = menu;
        this.domain = domainJO;
        this.subdomain = subDomainJO;
      }
    });

    this.searchTable = this.formBuilder.group({
      fuenteName: ["", Validators.required],
    });
  }

  clickBusquedaRds() {
    console.log('[previewDataTableTitle.clickBusquedaRds] Click en búsqueda RDS', this.dataPrimarykeyRds);
    console.log('[previewDataTableTitle.clickBusquedaRds] Tipo de clave seleccionada:', this.selectedKeyTypeRDS);

    const body = {
      data: this.dataPrimarykeyRds,
      type: this.selectedKeyTypeRDS, // Usar el valor seleccionado del dropdown
      key: ''
    };

    this.onDataPrimarykeyRds.emit(body);
  }

  getRdsDataByCollection() {
    this.onSearchRdsData.emit(true);
  }

  togglePanelFilter() {
    this.panelFilter = !this.panelFilter;
  }

  onReturn() {
    console.log('[previewDataTableTitle.onReturn] Emitiendo onToBackButton');
    this.onToBackButton.emit();
  }

  varibleCicloRds() {
    if (this.subscription && !this.subscription.closed) {
      return;
    }

    const intervalo = interval(1000); // Revisa cada 1 segundos

    this.subscription = intervalo.subscribe(() => {

      // console.log('[previewDataTableTitle.varibleCicloRds] Verificando cambios en localStorage para PrimaryKeyFieldRDS...');
      // console.log('[previewDataTableTitle.varibleCicloRds] Valor actual en localStorage:', this.localStorageService.getPrimaryKeyFieldRDS);
      // console.log('[previewDataTableTitle.varibleCicloRds] Valor de variable local antes de actualización:', this.variableLocalPrimaryKeyFieldRdsVista);
      // console.log('[previewDataTableTitle.varibleCicloRds] getDataview:', this.localStorageService.getDataview);
      const nuevoValor = this.localStorageService.getPrimaryKeyFieldRDS;
      if (this.variableLocalPrimaryKeyFieldRdsVista !== nuevoValor) {
        this.variableLocalPrimaryKeyFieldRdsVista = nuevoValor;
        this.cdr.detectChanges(); // Forzar la detección de cambios
        // console.log('Variable local actualizada (Forzado):', this.variableLocalPrimaryKeyFieldRdsVista);
      }
    });
  }

  openLogModal(): void {
    const dialogRef = this.dialog.open(LogsComponent, {
      width: '1200px',
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        isModalContext: true,
        initialMatchKey: this.localStorageService.getMatchkeySelected
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        console.log(`Modal closed with result: ${result}`);
      },
      (reason) => {
        console.log(`Modal dismissed with reason: ${reason}`);
      }
    );
  }

  /**
   * Lógica para mostrar el botón de Agregar.
   * Prioriza la nueva configuración (addPreview) si está definida.
   * Si no, recurre a la lógica antigua (buttonAdd, showAddObs).
   */
  get showAddButtonLogic(): boolean {
    // Para RDS, mostrar el botón Agregar si el usuario tiene permiso (independiente del schema)
    if (this.showRds && this.validRoleDis) {
      return true;
    }

    const newConfigIsDefined = this.addPreview !== undefined && this.addPreview !== null;

    if (newConfigIsDefined) {
      // Prioridad 1: Usar la nueva configuración.
      return (this.currentView === 'preview1' && this.addPreview) ||
        (this.currentView === 'preview2' && this.addPreviewTwo);
    } else {
      // Prioridad 2: Usar la lógica antigua como fallback.
      return this.buttonAdd || this.showAddObs;
    }
  }

  /**
   * Lógica para mostrar el botón de Eliminar.
   * Prioriza la nueva configuración (deletePreview) si está definida.
   * Si no, recurre a la lógica antigua (disableDeleteButton).
   */
  get showDeleteButtonLogic(): boolean {
    if (this.esInternoRdsVista) {
      return false;
    }
    const newConfigIsDefined = this.deletePreview !== undefined && this.deletePreview !== null;

    if (newConfigIsDefined) {
      // Prioridad 1: Usar la nueva configuración, respetando que debe haber una fila seleccionada.
      return this.isAnyRowSelected &&
        ((this.currentView === 'preview1' && this.deletePreview) ||
          (this.currentView === 'preview2' && this.deletePreviewTwo));
    } else {
      // Prioridad 2: Usar la propiedad antigua, que ya incluye la lógica de selección desde el padre.
      return this.disableDeleteButton;
    }
  }

  /**
   * Lógica para mostrar el botón de Edición Masiva.
   * Prioriza la nueva configuración (bulkEditPreview) si está definida.
   * Si no, recurre a la lógica antigua (conditionEdicionMasiva).
   */
  get showBulkEditButtonLogic(): boolean {
    if (this.esInternoRdsVista) {
      return false;
    }
    const newConfigIsDefined = this.bulkEditPreview !== undefined && this.bulkEditPreview !== null;

    if (newConfigIsDefined) {
      // Prioridad 1: Usar la nueva configuración, combinada con la condición de selección múltiple.
      return this.conditionEdicionMasiva() &&
        ((this.currentView === 'preview1' && this.bulkEditPreview) ||
          (this.currentView === 'preview2' && this.bulkEditPreviewTwo));
    } else {
      // Prioridad 2: Usar solo la condición original como fallback.
      return this.conditionEdicionMasiva();
    }
  }

  get showSoftDelete(): boolean {
    const isSegSolicitudes1 = this.nombreFuente?.includes('Seguimiento de RequestID') ?? false;
    const baseCondition = !this.localStorageService.getIsVip && !isSegSolicitudes1;

    // Para fuentes con doble preview siempre mostrar el toggle si hay baseUrlfuente
    if (this.isMultiplePreview && this._baseUrlfuente) {
      return baseCondition;
    }

    if (!this._baseUrlfuente) {
      return false;
    }
    return (this._baseUrlfuente.includes('/v4/') || this._baseUrlfuente.includes('/lastmk/'))
      && baseCondition;
  }

}
